<template>
  <div class="document-tab documents">
    <form id="upload-doc" enctype="multipart/form-data">
      <Upload
        name="filename_file"
        :file="filename_file"
        :multiple="true"
        :show-file-list="false"
        uploadText="Перетащите сюда любой документ"
        class="document-tab__upload"
        @upload-file="uploadDocument"
      ></Upload>
    </form>
    <Divider hasLine dividerSize="1" />
    <div v-if="!documents.length" class="document-tab__alert">
      <Alert text="Нет прикрепленных документов" />
    </div>

    <SubpanelTable
      v-if="documents.length"
      :tableColumns="tableColumns"
      :tableData="documents"
      :allowDelete="true"
      @downloadFile="downloadFile"
      @handleDelete="showDocumentDialog"
      :class="[
        'document-tab__list',
        isVacancy ? 'documents-vacancy' : '',
        isRespond ? 'documents-respond' : '',
        isCandidate ? 'documents-candidate' : '',
        isCoordination ? 'documents-coordination' : ''
      ]"
    />
  </div>
</template>

<script>
import { getController, postController } from '@/controllers/request.js';
import { mixin } from '@/utils/mixins';
import Divider from 'Elements/Divider/Divider';
import Alert from 'Elements/Alert/Alert';
import Upload from 'Elements/Upload/Upload';
import SubpanelTable from 'Elements/Table/SubpanelTable';
import { MODULE, ACTION, EVENTBUS_EVENTS } from '@/utils/constants';
import { eventBus } from '@/bus';

export default {
  mixins: [mixin],
  props: {
    userId: {
      type: String
    },
    module: {
      type: String,
      default: MODULE.VACANCY_MODULE
    },
    id: {
      type: String
    },

    metadata: [Array, Object]
  },
  data() {
    return {
      documents: [],
      deletedDoc: null,
      filename_file: [],
      tableSql: '',
      tableColumns: {
        filename: {
          lbl: {
            value: 'Файл'
          }
        },
        date_entered: {
          lbl: {
            value: 'Дата и время загрузки'
          }
        },
        created_by_name: {
          lbl: {
            value: 'Автор'
          }
        }
      },
      is_visible: {
        document_dialog: false
      }
    };
  },
  created() {
    if (this.metadata?.List?.length || this.metadata?.data?.List?.length) {
      this.documents = this.metadata?.List || this.metadata?.data?.List;
    }

    this.tableSql =
      this.module === MODULE.CANDIDATES_MODULE
        ? 'hrpac_candidates_documents_1'
        : this.module === MODULE.CANDIDATE_RESPONDS
        ? 'hrpac_candidate_responds_documents_link'
        : this.module === MODULE.COORDINATION ||
          this.module === MODULE.COORDINATION_REQUEST
        ? 'hrpac_coordination_documents_1'
        : 'hrpac_vacancy_documents_1';

    eventBus.$on('deleteDocument', this.removeDocument);
  },
  beforeDestroy() {
    eventBus.$off('deleteDocument', this.removeDocument);
  },
  computed: {
    isVacancy() {
      return this.module === MODULE.VACANCY_MODULE;
    },
    isRespond() {
      return this.module === MODULE.CANDIDATE_RESPONDS;
    },
    isCandidate() {
      return this.module === MODULE.CANDIDATES_MODULE;
    },
    isCoordination() {
      return (
        this.module === MODULE.COORDINATION ||
        this.module === MODULE.COORDINATION_REQUEST
      );
    }
  },
  methods: {
    downloadFile(id) {
      let url =
        '/index.php?entryPoint=download_spa' + `&id=${id}` + `&type=Documents`;
      getController({
        url
      })
        .then(resp => {
          let blob = new Blob([this.s2ab(atob(resp.data.fileData))], {
            type: resp.data.fileType
          });
          let url = URL.createObjectURL(blob);
          let a = document.createElement('a');

          document.body.appendChild(a);
          a.style = 'display: none';
          a.href = url;
          a.download = resp.data.fileName;
          a.click();
          a.remove();
          URL.revokeObjectURL(url);

          this.deletedDoc = null;
        })
        .catch(() =>
          this.showFullNotification({
            title: 'Ошибка загрузки',
            showClose: true,
            type: 'error',
            customClass: 'vacancy-success__toast',
            position: 'top-left',
            duration: 10000,
            offset: 100
          })
        );
    },
    s2ab(s) {
      let buf = new ArrayBuffer(s.length);
      let view = new Uint8Array(buf);
      for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;

      return buf;
    },
    updateDocumentsList() {
      this.$emit('reloadTab');
    },
    showDocumentDialog(doc) {
      this.deletedDoc = doc;
      eventBus.$emit(EVENTBUS_EVENTS.ASK_TO_DELETE_DOCUMENT);
    },
    removeDocument() {
      const iscreated_by_name =
        this.deletedDoc && (this.userId === this.deletedDoc.created_by || true);

      if (iscreated_by_name) {
        getController({
          params: {
            module: this.module,
            action: ACTION.DELETE_RELATIONSHIP,
            record: this.id,
            return_action: ACTION.DELETE_RELATIONSHIP,
            return_module: this.module,
            return_id: this.id,
            linked_field: this.tableSql,
            linked_id:
              this.deletedDoc.id && this.deletedDoc.id.value
                ? this.deletedDoc.id.value
                : this.deletedDoc.id,
            refresh_page: 0,
            inline: 1,
            ajaxSubpanel: true
          }
        })
          .then(() => {
            this.deletedDoc = null;
            this.updateDocumentsList();
          })
          .catch(err =>
            this.catchError(
              err,
              'Возникла ошибка при удалении документа',
              'document remove'
            )
          );
      }
    },
    updateFormData(newId, formData) {
      formData.set('module', MODULE.DOCUMENTS);
      formData.set('action', ACTION.SAVE);
      formData.set('relate_to', this.tableSql);
      formData.set('relate_id', newId);
      formData.set('parent_type', this.module);
      formData.set('parent_id', newId);
      formData.set('revision', 1);
      formData.set('jsqon_return', 1);
      return formData;
    },
    uploadDocument(file) {
      const form = document.getElementById('upload-doc');
      let formData = new FormData(form);
      formData = this.updateFormData(this.id, formData);

      this.documents.push({ file: file.name });

      if (file) {
        const { raw: blob, name } = file;
        formData.set('filename_file', blob, name);

        const params = {
          header: {
            'Content-Type': 'multipart/form-data'
          }
        };

        postController({ options: formData, params })
          .then(() => {
            this.filename_file = [];
          })
          .catch(err =>
            console.error(
              err,
              'Возникла ошибка при загрузке документа',
              'upload file'
            )
          )
          .finally(() => {
            this.updateDocumentsList();
          });
      }
    }
  },
  components: {
    Upload,
    Alert,
    SubpanelTable,
    Divider
  }
};
</script>

<style lang="scss" scoped>
.documents {
  display: flex;
  flex-direction: column;

  .document-tab__list {
    padding: 24px;
  }

  #upload-doc {
    padding: 24px;
  }

  &-respond {
    height: calc(100vh - 315px) !important;
  }

  &-coordination {
    height: calc(100vh - 392px) !important;
  }

  .document-tab__alert {
    padding: 24px;
  }
}
</style>
